import fetch from '@/utils/fetch'
import {wymsFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 经销商管理
 * */
/**
 * 查询经销商列表
 * */
export function getDealerManageList(args) {
  return wymsFetch({
    url: 'bussiness/queryBussinessList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询经销商列表全部
 * */
export function getAllDealerManageList(args) {
  return wymsFetch({
    url: 'bussiness/queryBussinessListAll',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增经销商
 * */
export function insertDealer(args) {
  return wymsFetch({
    url: 'bussiness/insertBussiness',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑经销商
 * */
export function updateDealer(args) {
  return wymsFetch({
    url: 'bussiness/updateBussiness',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除经销商
 * */
export function deleteDealer(args) {
  return wymsFetch({
    url: 'bussiness/deleteBussiness',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询经销商
 * */
export function queryDealer(args) {
  return wymsFetch({
    url: 'bussiness/queryBussiness',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询经销商用户列表
 * */
export function queryBusinessNumberList(args) {
  return wymsFetch({
    url: 'bussiness/queryBusinessNumberList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增经销商用户
 * */
export function insertBusinessNumber(args) {
  return wymsFetch({
    url: 'bussiness/insertBusinessNumber',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除经销商用户
 * */
export function deleteBusinessNumber(args) {
  return wymsFetch({
    url: 'bussiness/deleteBusinessNumber',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 客服组管理
 * */
/**
 * 客服组列表
 * */
export function listGroup(args) {
  return wymsFetch({
    url: 'customerGroup/listGroup',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增客服组
 * */
export function addGroup(args) {
  return wymsFetch({
    url: 'customerGroup/addGroup',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 修改客服组
 * */
export function updateGroup(args) {
  return wymsFetch({
    url: 'customerGroup/updateGroup',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除客服组
 * */
export function deleteGroup(args) {
  return wymsFetch({
    url: 'customerGroup/deleteGroup',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 客服组详情
 * */
export function detailGroup(args) {
  return wymsFetch({
    url: 'customerGroup/detail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 平台角色管理
 * */
/**
 * 查询平台角色
 * */
export function queryRoleList(args) {
  return wymsFetch({
    url: 'platformRole/queryRoleList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询角色用户
 * */
export function queryRoleUserList(args) {
  return wymsFetch({
    url: 'platformRole/queryRoleUserList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 添加用户
 * */
export function insertRoleUser(args) {
  return wymsFetch({
    url: 'platformRole/insertRoleUser',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 移除用户
 * */
export function deleteByRoleIdAndUserId(args) {
  return wymsFetch({
    url: 'platformRole/deleteByRoleIdAndUserId',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 经销商套件设置
 * */
/**
 * 查询套件列表
 * */
export function querySuiteList(args) {
  return wymsFetch({
    url: 'businessSuite/querySuiteList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询经销商套件列表
 * */
export function queryBussinessSuiteList(args) {
  return wymsFetch({
    url: 'businessSuite/queryBussinessSuiteList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑经销商套件
 * */
export function updateBussinessSuite(args) {
  return wymsFetch({
    url: 'businessSuite/updateBussinessSuite',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}



// WEBPACK FOOTER //
// ./src/api/dealerManage.js